import { cn } from '../../../lib/styles';
import type { TextProps, TextSize, TextVariant } from './types';

const SIZE_MAP: Record<TextSize, string> = {
  sm: 'text-xs',
  md: 'text-sm',
  lg: 'text-xl',
  xl: 'text-3xl',
};

export const TEXT_VARIANT_MAP: Record<TextVariant, string> = {
  primary: 'text-spark-text-primary',
  secondary: 'text-spark-text-secondary',
};

export function Text({
  variant = 'primary',
  size = 'md',
  truncate,
  bold,
  id,
  mono,
  children,
}: TextProps) {
  return (
    <p
      id={id}
      className={cn(
        SIZE_MAP[size],
        TEXT_VARIANT_MAP[variant],
        truncate && 'truncate',
        bold && 'font-semibold',
        mono && 'font-mono',
      )}
    >
      {children}
    </p>
  );
}
